import { useState, useEffect } from 'react';
import { Flex, Heading, Image, Button, Link } from '@chakra-ui/react';
import { useAuthContext } from '../../hooks/auth';
import { FiLogOut } from 'react-icons/fi';
import style from './styles.module.scss';
import logoImg from '../../assets/tech4humans.png';
import { faListDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AUTH_KEYS = {
  AUTHORIZATION: 'Authorization',
  AUTHORIZATION_RA: 'AuthorizationRA',
  AUTHORIZATION_FORCE: 'Authorization_force',
  CLIENT_ID_FORCE: 'clientIdForce',
  SESSION: 'SESSION_KEY',
  LOGOUT_TIMEOUT: 'LOGOUT_TIMEOUT_KEY',
  SLUG: 'slug',
  AMBIENT: 'ambient_to',
  IN_FORCE: 'inForce',
} as const;

// Componente separado apenas para o timer da sessão
function SessionTimer() {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  useEffect(() => {
    const updateTimeLeft = () => {
      const logoutTime = localStorage.getItem("LOGOUT_TIMEOUT_KEY");
      if (logoutTime) {
        const timeRemaining = parseInt(logoutTime) - new Date().getTime();
        setTimeLeft(timeRemaining > 0 ? timeRemaining : 0);
      }
    };
    updateTimeLeft(); // Atualiza imediatamente
    const intervalId = setInterval(updateTimeLeft, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 3600000);
    const minutes = Math.floor((time % 3600000) / 60000);
    const seconds = Math.floor((time % 60000) / 1000);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <Flex alignItems="center" direction="column">
      <Heading>Sessão</Heading>
      <Heading style={{ fontWeight: 'bold' }}>{formatTime(timeLeft)}</Heading>
    </Flex>
  );
}

export function Header({
  toggleActiveSidebar,
  activeSidebar,
}: {
  toggleActiveSidebar: () => void;
  activeSidebar: boolean;
}) {
  const { user, signOut } = useAuthContext();

  const storedInForce = localStorage.getItem(AUTH_KEYS.IN_FORCE);
  let rcForce: string;

  if (storedInForce === "false") {
    rcForce = "RC";
  } else {
    rcForce = "FORCE";
  }

  return (
    <Flex
      onClick={() => {
        if (activeSidebar) {
          toggleActiveSidebar();
        }
      }}
      height='5rem'
      padding={4}
      justifyContent='space-between'
      alignItems='center'
      boxShadow='md'
      position='fixed'
      width='100%'
      zIndex='1000'
      className={style.headerContainer}
    >
      <span className={style.spanButton} onClick={() => toggleActiveSidebar()}>
        <FontAwesomeIcon icon={faListDots} className={style.faIcon} style={{ color: 'black', fontSize: '2rem' }} />
      </span>
      <Link href='/section'>
        <Image src={logoImg} width='100px' height='50px' />
      </Link>

      <SessionTimer />

      {/* <Flex style={{ flexDirection: 'column' }}>
        <Heading style={{ marginLeft: '0.5rem', fontSize: '1rem' }}>Cliente:</Heading>
        <Heading style={{ marginLeft: '0.5rem', fontSize: '1rem', fontWeight: 'bold' }}>
          {user?.clientName}
        </Heading>
      </Flex> */}

      <Flex style={{ flexDirection: 'column' }}>
        {/* <Heading style={{ marginLeft: '0.5rem', fontSize: '1rem' }}>Usuário Logado:</Heading> */}
        <Heading style={{ marginLeft: '0.5rem', fontSize: '2rem', fontWeight: 'bold' }}>
          {user?.userName}
        </Heading>
      </Flex>

      {/* <Flex style={{ flexDirection: 'column' }}>
        <Heading style={{ marginLeft: '0.5rem', fontSize: '1rem' }}>Email:</Heading>
        <Heading style={{ marginLeft: '0.5rem', fontSize: '1rem', fontWeight: 'bold' }} className={style.info}>
          {user?.userEmail}
        </Heading>
      </Flex> */}

      <Flex style={{ flexDirection: 'column' }}>
        <Heading style={{ marginLeft: '0.5rem', fontSize: '2rem', fontWeight: 'bold' }}>
          {rcForce}
        </Heading>
      </Flex>

      <Button onClick={signOut} className={style.logoutButton}>
        <FiLogOut size={24} className={style.logoutButton} />
      </Button>

    </Flex>
  );
}